import {
  makeLabeler,
  makeRegionLabeler,
  useCommonCodes,
  useDongs,
  useTargetCodes,
} from '@/shared/lib/codes'

export function useCardLabels() {
  const categories = useCommonCodes('category')
  const targets = useTargetCodes()
  const dongs = useDongs()

  return {
    categoryLabel: makeLabeler(categories.data),
    targetLabel: makeLabeler(targets.data),
    dongLabel: makeRegionLabeler(dongs.data),
    isReady:
      categories.data !== undefined && targets.data !== undefined && dongs.data !== undefined,
  }
}

export function useSolutionCardLabels() {
  const base = useCardLabels()
  const resources = useCommonCodes('resource')
  const areas = useCommonCodes('service_area')
  const costs = useCommonCodes('cost_type')

  return {
    ...base,
    resourceLabel: makeLabeler(resources.data),
    serviceAreaLabel: makeLabeler(areas.data),
    costTypeLabel: makeLabeler(costs.data),
    isReady:
      base.isReady &&
      resources.data !== undefined &&
      areas.data !== undefined &&
      costs.data !== undefined,
  }
}

export type CardLabels = ReturnType<typeof useCardLabels>
export type SolutionCardLabels = ReturnType<typeof useSolutionCardLabels>
